export enum CardDismissalActions {
  SET_CARD_DISMISSALS = 'SET_CARD_DISMISSALS',
  CREATE_CARD_DISMISSAL = 'CREATE_CARD_DISMISSAL',
  DELETE_CARD_DISMISSAL = 'DELETE_CARD_DISMISSAL',
}
